import React from 'react';

export const PlayerImageIcon = () => (
    <div className="relative flex items-center justify-center" style={{ width: 'clamp(50px, 6vw, 80px)', height: 'clamp(50px, 6vw, 80px)' }}>
      {/* Stars */}
      <div className="absolute inset-0 z-0">
        <span className="absolute top-10 left-[-2px] text-yellow-400 animate-pulse" style={{ fontSize: 'clamp(0.75rem, 1vw, 1.125rem)' }}>✦</span>
        <span className="absolute top-10 right-[-2px] text-yellow-400 animate-pulse delay-75" style={{ fontSize: 'clamp(0.75rem, 1vw, 1.125rem)' }}>✦</span>
      </div>

      {/* Cartoon Player */}
      <svg width="70" height="70" viewBox="0 0 100 100" className="relative z-10 drop-shadow-lg" style={{ width: 'clamp(44px, 5vw, 70px)', height: 'clamp(44px, 5vw, 70px)' }}>
        {/* Hair */}
        <path d="M25,35 Q25,10 50,10 Q75,10 75,35 L75,45 L25,45 Z" fill="#5D4037" />

        {/* Face */}
        <path d="M30,35 Q30,20 50,20 Q70,20 70,35 L70,60 Q70,75 50,75 Q30,75 30,60 Z" fill="#FFCCBC" />

        {/* Eyes */}
        <circle cx="40" cy="45" r="3" fill="#333" />
        <circle cx="60" cy="45" r="3" fill="#333" />

        {/* Smile */}
        <path d="M40,60 Q50,68 60,60" fill="none" stroke="#D84315" strokeWidth="2.5" strokeLinecap="round" />

        {/* Ears */}
        <circle cx="28" cy="45" r="5" fill="#FFCCBC" />
        <circle cx="72" cy="45" r="5" fill="#FFCCBC" />

        {/* Jersey */}
        <path d="M15,90 Q15,80 30,75 L70,75 Q85,80 85,90 L85,100 L15,100 Z" fill="white" />
        {/* Blue Collar/Trim */}
        <path d="M30,75 L40,85 L60,85 L70,75" fill="none" stroke="#1E88E5" strokeWidth="5" strokeLinecap="round" />
      </svg>
    </div>
);


export const DrawGameIcon = () => (
    <div className="relative flex items-center justify-center" style={{ width: 'clamp(50px, 6vw, 80px)', height: 'clamp(50px, 6vw, 80px)' }}>
      {/* Pencil Logo */}
      <svg viewBox="0 0 100 100" className="relative z-20 transform rotate-[45deg] filter drop-shadow-lg" style={{ width: 'clamp(42px, 5vw, 64px)', height: 'clamp(42px, 5vw, 64px)' }}>
        <g transform="translate(0, 2)">
          {/* Pencil Body */}
          <rect x="35" y="10" width="30" height="55" fill="#fbbf24" rx="2"/>
          <rect x="45" y="10" width="10" height="55" fill="#f59e0b"/> {/* Shading */}
          
          {/* Eraser */}
          <path d="M35 10 L35 0 L65 0 L65 10 Z" fill="#f472b6"/>
          <rect x="35" y="7" width="30" height="6" fill="#9ca3af"/> {/* Metal band */}
          
          {/* Sharpened Tip */}
          <path d="M35 65 L50 95 L65 65 Z" fill="#fef3c7"/>
          <path d="M44 82 L50 95 L56 82 Z" fill="#1f2937"/> {/* Lead */}
        </g>
      </svg>

      {/* Drawing Path in background */}
      <svg viewBox="0 0 100 100" className="absolute z-0 opacity-10" style={{ width: 'clamp(50px, 6vw, 80px)', height: 'clamp(38px, 4.5vw, 60px)' }}>
        <path d="M70 20 Q90 50 50 80 T10 40" fill="none" stroke="white" strokeWidth="4" strokeDasharray="8 4"/>
      </svg>
    </div>
);


export const BuySellIcon = () => (
    <div className="relative flex items-center justify-center" style={{ width: 'clamp(40px, 5vw, 64px)', height: 'clamp(60px, 7vw, 96px)' }}>
      {/* Shopping Cart */}
      <div className="relative z-10 transform translate-y-2">
        {/* Cart Body */}
        <svg viewBox="0 0 60 50" style={{ width: 'clamp(38px, 4.5vw, 60px)', height: 'clamp(32px, 3.8vw, 50px)' }}>
          <path d="M10,10 L50,10 L45,35 L15,35 Z" fill="white" stroke="#333" strokeWidth="2" />
          <rect x="15" y="15" width="30" height="15" fill="#22C55E" rx="2" /> {/* Green stripe */}
          <rect x="20" y="18" width="20" height="8" fill="#F97316" rx="1" /> {/* Orange stripe */}
          {/* Wheels */}
          <circle cx="20" cy="42" r="4" fill="#333" />
          <circle cx="40" cy="42" r="4" fill="#333" />
          {/* Handle */}
          <path d="M10,10 L5,5" stroke="#333" strokeWidth="3" strokeLinecap="round" />
        </svg>

        {/* Items in Cart */}
        <div className="absolute top-[-15px] left-[15px] z-20 flex items-end">
          {/* Soccer Ball */}
          <svg viewBox="0 0 50 50" style={{ width: 'clamp(15px, 1.8vw, 24px)', height: 'clamp(15px, 1.8vw, 24px)' }}>
            <circle cx="25" cy="25" r="23" fill="white" stroke="#333" strokeWidth="2"/>
            <path d="M25 10 L35 18 L31 32 L19 32 L15 18 Z" fill="#333"/>
          </svg>
        </div>
      </div>

      {/* Sparkles */}
      <div className="absolute inset-0 z-0">
        <span className="absolute top-4 left-4 text-yellow-400 animate-pulse">✦</span>
        <span className="absolute bottom-8 right-4 text-yellow-400 animate-pulse delay-75">✦</span>
      </div>
    </div>
);


export const SoundBoardIcon = () => (
    <div className="relative flex items-center justify-center" style={{ width: 'clamp(40px, 5vw, 64px)', height: 'clamp(60px, 7vw, 96px)' }}>
       {/* Background Leaves/Shapes */}
       <div className="absolute inset-0 flex items-center justify-center opacity-30">
          <div className="bg-blue-400 rounded-full blur-xl" style={{ width: 'clamp(40px, 5vw, 64px)', height: 'clamp(40px, 5vw, 64px)' }}></div>
          <div className="absolute top-4 left-6 bg-green-400 rounded-full blur-lg" style={{ width: 'clamp(20px, 2.5vw, 32px)', height: 'clamp(20px, 2.5vw, 32px)' }}></div>
       </div>

       {/* Flask/Beaker */}
       <div className="relative z-10">
          <svg viewBox="0 0 50 60" style={{ width: 'clamp(32px, 3.8vw, 50px)', height: 'clamp(38px, 4.5vw, 60px)' }}>
            {/* Glass Body */}
            <path d="M15,10 L35,10 L35,25 L45,50 L5,50 L15,25 Z" fill="white" fillOpacity="0.3" stroke="white" strokeWidth="2" />
            {/* Liquid */}
            <path d="M10,40 L40,40 L45,50 L5,50 Z" fill="#3B82F6" />
            {/* Bubbles */}
            <circle cx="20" cy="35" r="2" fill="white" opacity="0.6" />
            <circle cx="30" cy="45" r="3" fill="white" opacity="0.4" />
            {/* Rim */}
            <rect x="12" y="8" width="26" height="4" fill="white" rx="2" />
          </svg>
          
          {/* Orange/Ball next to flask */}
          <div className="absolute bottom-0 left-[-10px] bg-orange-500 rounded-full border-2 border-orange-600 shadow-lg" style={{ width: 'clamp(25px, 3vw, 40px)', height: 'clamp(25px, 3vw, 40px)' }}>
             <div className="absolute top-1 left-2 bg-white/40 rounded-full" style={{ width: 'clamp(5px, 0.6vw, 8px)', height: 'clamp(5px, 0.6vw, 8px)' }}></div>
          </div>
       </div>

       {/* Sparkles */}
       <div className="absolute inset-0 z-20 pointer-events-none">
          <span className="absolute top-6 right-6 text-white text-xs animate-ping">✨</span>
          <span className="absolute top-10 left-8 text-white text-xs animate-ping delay-100">✨</span>
       </div>
    </div>
);


export const SellSellIcon = () => (
    <div className="relative flex items-center justify-center" style={{ width: 'clamp(50px, 6vw, 80px)', height: 'clamp(60px, 7vw, 96px)' }}>
       {/* Money behind cart - Green stack */}
       <div className="absolute right-[-5px] bottom-6 z-0">
          <div className="bg-green-500 border border-green-700 rounded-sm transform rotate-12 shadow-sm" style={{ width: 'clamp(25px, 3vw, 40px)', height: 'clamp(15px, 1.8vw, 24px)' }}></div>
          <div className="absolute top-[-2px] left-[-2px] bg-green-600 border border-green-800 rounded-sm transform -rotate-6 shadow-sm" style={{ width: 'clamp(25px, 3vw, 40px)', height: 'clamp(15px, 1.8vw, 24px)' }}></div>
       </div>

       {/* Shopping Cart */}
       <div className="relative z-10">
          <svg viewBox="0 0 80 70" style={{ width: 'clamp(41px, 5vw, 65px)', height: 'clamp(35px, 4.2vw, 55px)' }}>
            {/* Cart Body */}
            <path d="M15,15 L75,15 L70,45 L20,45 Z" fill="white" stroke="#333" strokeWidth="2.5" />
            {/* Stripes */}
            <rect x="22" y="20" width="48" height="10" fill="#22C55E" rx="1" />
            <rect x="22" y="30" width="48" height="10" fill="#FACC15" rx="1" />
            
            {/* Handle */}
            <path d="M15,15 L8,8" stroke="#333" strokeWidth="3.5" strokeLinecap="round" />
            
            {/* Wheels */}
            <circle cx="30" cy="55" r="6" fill="#333" />
            <circle cx="60" cy="55" r="6" fill="#333" />
            <circle cx="30" cy="55" r="2.5" fill="#999" />
            <circle cx="60" cy="55" r="2.5" fill="#999" />
          </svg>

          {/* Soccer Ball in cart */}
          <div className="absolute top-[-15px] left-[20px] z-20">
             <svg viewBox="0 0 50 50" style={{ width: 'clamp(23px, 2.7vw, 36px)', height: 'clamp(23px, 2.7vw, 36px)' }}>
               <circle cx="25" cy="25" r="23" fill="white" stroke="#333" strokeWidth="2.5"/>
               <path d="M25 10 L35 18 L31 32 L19 32 L15 18 Z" fill="#333"/>
               <path d="M25 10 L25 2 M35 18 L45 15 M31 32 L38 45 M19 32 L12 45 M15 18 L5 15" stroke="#333" strokeWidth="2.5" />
             </svg>
          </div>
       </div>
       
       {/* Sparkles */}
       <div className="absolute inset-0 z-20 pointer-events-none">
          <span className="absolute top-4 right-0 text-yellow-300 animate-pulse" style={{ fontSize: 'clamp(0.75rem, 1vw, 0.875rem)' }}>✦</span>
          <span className="absolute top-12 left-0 text-yellow-300 animate-pulse delay-75" style={{ fontSize: 'clamp(0.6rem, 0.8vw, 0.75rem)' }}>✦</span>
          <span className="absolute bottom-8 right-2 text-yellow-200 animate-pulse delay-150" style={{ fontSize: 'clamp(0.5rem, 0.6vw, 0.625rem)' }}>✦</span>
       </div>
    </div>
);


export const QuestionIcon = () => (
    <div className="relative flex items-center justify-center" style={{ width: 'clamp(50px, 6vw, 80px)', height: 'clamp(50px, 6vw, 80px)' }}>
      <div
        className="relative z-10 rounded-full bg-blue-900/45 flex items-center justify-center shadow-md"
        style={{ width: 'clamp(42px, 5vw, 64px)', height: 'clamp(42px, 5vw, 64px)' }}
      >
        <span className="text-white font-black drop-shadow-md leading-none" style={{ fontSize: 'clamp(2.1rem, 4.2vw, 3.2rem)' }}>?</span>
      </div>
    </div>
);


export const QuizIcon = () => (
    <div className="relative flex items-center justify-center" style={{ width: 'clamp(40px, 5vw, 64px)', height: 'clamp(40px, 5vw, 64px)' }}>
      {/* Shadow/Base */}
      <div className="absolute bottom-0 bg-green-800/40 rounded-xl translate-y-1" style={{ width: 'clamp(35px, 4.2vw, 56px)', height: 'clamp(35px, 4.2vw, 56px)' }}></div>
      {/* White Square */}
      <div className="relative bg-white rounded-xl flex items-center justify-center border border-gray-100 shadow-sm" style={{ width: 'clamp(35px, 4.2vw, 56px)', height: 'clamp(35px, 4.2vw, 56px)' }}>
        <svg viewBox="0 0 24 24" fill="none" stroke="#15803d" strokeWidth="7" strokeLinecap="round" strokeLinejoin="round" style={{ width: 'clamp(20px, 2.4vw, 32px)', height: 'clamp(20px, 2.4vw, 32px)' }}>
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      </div>
    </div>
);


export const CalendarIcon = () => (
    <div className="relative flex items-center justify-center" style={{ width: 'clamp(50px, 6vw, 80px)', height: 'clamp(50px, 6vw, 80px)' }}>
      <div className="bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden relative" style={{ width: 'clamp(40px, 5vw, 64px)', height: 'clamp(40px, 5vw, 64px)' }}>
        {/* Purple Top */}
        <div className="bg-purple-600 w-full flex justify-around items-center px-2" style={{ height: 'clamp(12px, 1.5vw, 20px)' }}>
          <div className="bg-white/50 rounded-full" style={{ width: 'clamp(3px, 0.4vw, 6px)', height: 'clamp(3px, 0.4vw, 6px)' }}></div>
          <div className="bg-white/50 rounded-full" style={{ width: 'clamp(3px, 0.4vw, 6px)', height: 'clamp(3px, 0.4vw, 6px)' }}></div>
        </div>
        {/* Grid lines */}
        <div className="p-1 grid grid-cols-3 gap-1 opacity-20">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="bg-gray-400 rounded-sm" style={{ height: 'clamp(4px, 0.5vw, 8px)' }}></div>
          ))}
        </div>
        {/* Star */}
        <div className="absolute bottom-1 right-1">
          <svg viewBox="0 0 24 24" fill="#fbce1b" style={{ width: 'clamp(15px, 1.8vw, 24px)', height: 'clamp(15px, 1.8vw, 24px)' }}>
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
          </svg>
        </div>
      </div>
      {/* Rings */}
      <div className="absolute top-1 left-1/2 -translate-x-1/2 flex gap-6">
        <div className="bg-gray-300 rounded-full border border-gray-400" style={{ width: 'clamp(5px, 0.6vw, 8px)', height: 'clamp(10px, 1.2vw, 16px)' }}></div>
        <div className="bg-gray-300 rounded-full border border-gray-400" style={{ width: 'clamp(5px, 0.6vw, 8px)', height: 'clamp(10px, 1.2vw, 16px)' }}></div>
      </div>
    </div>
);


export const DilemmaIcon = () => (
    <div className="relative flex items-center justify-center" style={{ width: 'clamp(60px, 7.2vw, 96px)', height: 'clamp(50px, 6vw, 80px)' }}>
      {/* Teal Cup */}
      <div className="absolute left-1 bottom-2 transform -rotate-6">
        <svg viewBox="0 0 40 40" style={{ width: 'clamp(26px, 3.2vw, 42px)', height: 'clamp(26px, 3.2vw, 42px)' }}>
          <defs>
            <linearGradient id="tealCupGrad" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#4fd1c5" />
              <stop offset="100%" stopColor="#285e61" />
            </linearGradient>
          </defs>
          <path d="M8,12 Q8,8 12,8 L28,8 Q32,8 32,12 L30,24 Q30,32 20,32 Q10,32 10,24 Z" fill="url(#tealCupGrad)" stroke="#134e4a" strokeWidth="1.5" />
          <path d="M10,11 Q20,9 30,11" fill="none" stroke="white" strokeWidth="1" strokeOpacity="0.3" />
          <path d="M16,32 L24,32 L25,36 L15,36 Z" fill="#134e4a" />
        </svg>
      </div>
      
      {/* Yellow Cup */}
      <div className="absolute right-1 bottom-2 transform rotate-6">
        <svg viewBox="0 0 40 40" style={{ width: 'clamp(26px, 3.2vw, 42px)', height: 'clamp(26px, 3.2vw, 42px)' }}>
          <defs>
            <linearGradient id="goldCupGrad" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#f6e05e" />
              <stop offset="100%" stopColor="#b7791f" />
            </linearGradient>
          </defs>
          <path d="M8,12 Q8,8 12,8 L28,8 Q32,8 32,12 L30,24 Q30,32 20,32 Q10,32 10,24 Z" fill="url(#goldCupGrad)" stroke="#744210" strokeWidth="1.5" />
          <path d="M10,11 Q20,9 30,11" fill="none" stroke="white" strokeWidth="1" strokeOpacity="0.4" />
          <path d="M16,32 L24,32 L25,36 L15,36 Z" fill="#744210" />
        </svg>
      </div>

      {/* Lightning Bolt */}
      <div className="absolute z-20 top-0 transform translate-y-1">
        <svg viewBox="0 0 24 24" className="filter drop-shadow-[0_2px_4px_rgba(0,0,0,0.3)]" style={{ width: 'clamp(28px, 3.4vw, 45px)', height: 'clamp(35px, 4.2vw, 55px)' }}>
          <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" fill="white" stroke="#e2e8f0" strokeWidth="0.5" />
        </svg>
      </div>

      {/* Sparkles */}
      <div className="absolute inset-0 pointer-events-none z-30">
        <div className="absolute top-2 left-4 bg-white rotate-45 opacity-80" style={{ width: 'clamp(4px, 0.5vw, 6px)', height: 'clamp(4px, 0.5vw, 6px)' }}></div>
        <div className="absolute top-6 left-2 bg-white rotate-45 opacity-60" style={{ width: 'clamp(3px, 0.4vw, 4px)', height: 'clamp(3px, 0.4vw, 4px)' }}></div>
        <div className="absolute bottom-8 right-4 bg-white rotate-45 opacity-80" style={{ width: 'clamp(4px, 0.5vw, 6px)', height: 'clamp(4px, 0.5vw, 6px)' }}></div>
        <div className="absolute top-10 right-2 bg-white rotate-45 opacity-60" style={{ width: 'clamp(3px, 0.4vw, 4px)', height: 'clamp(3px, 0.4vw, 4px)' }}></div>
      </div>
    </div>
);


export const CountryBattleIcon = () => (
    <div className="flex items-end justify-center relative w-full h-full pb-2">
      {/* India Flag */}
      <div className="relative transform -rotate-[25deg] origin-bottom-right z-10 translate-x-2">
        <div className="bg-gradient-to-b from-gray-200 to-gray-400 absolute right-[-2px] top-0 rounded-full shadow-md border-r border-gray-400" style={{ width: 'clamp(3px, 0.4vw, 6px)', height: 'clamp(60px, 7.2vw, 96px)' }}></div>
        <svg viewBox="0 0 70 46" className="filter drop-shadow-2xl" style={{ width: 'clamp(50px, 6vw, 80px)', height: 'clamp(33px, 4vw, 52px)' }}>
          <defs>
            <linearGradient id="indiaGrad" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#FF9933" />
              <stop offset="33%" stopColor="#FF9933" />
              <stop offset="33%" stopColor="#FFFFFF" />
              <stop offset="66%" stopColor="#FFFFFF" />
              <stop offset="66%" stopColor="#138808" />
              <stop offset="100%" stopColor="#138808" />
            </linearGradient>
          </defs>
          <path d="M0,2 Q35,-3 70,2 L70,44 Q35,39 0,44 Z" fill="url(#indiaGrad)" />
          <circle cx="35" cy="23" r="7" fill="none" stroke="#000080" strokeWidth="1.5" />
          <g stroke="#000080" strokeWidth="0.5">
             {[...Array(24)].map((_, i) => (
               <line key={i} x1="35" y1="23" x2={35 + 7 * Math.cos(i * Math.PI / 12)} y2={23 + 7 * Math.sin(i * Math.PI / 12)} />
             ))}
          </g>
        </svg>
      </div>

      {/* VS Center Point */}
      <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 z-20">
         <div className="bg-white rounded-full shadow-lg border-2 border-yellow-400" style={{ width: 'clamp(10px, 1.2vw, 16px)', height: 'clamp(10px, 1.2vw, 16px)' }}></div>
      </div>

      {/* Pakistan Flag */}
      <div className="relative transform rotate-[25deg] origin-bottom-left z-10 -translate-x-2">
        <div className="bg-gradient-to-b from-gray-200 to-gray-400 absolute left-[-2px] top-0 rounded-full shadow-md border-l border-gray-400" style={{ width: 'clamp(3px, 0.4vw, 6px)', height: 'clamp(60px, 7.2vw, 96px)' }}></div>
        <svg viewBox="0 0 70 46" className="filter drop-shadow-2xl" style={{ width: 'clamp(50px, 6vw, 80px)', height: 'clamp(33px, 4vw, 52px)' }}>
          <rect width="70" height="46" fill="#006600" rx="2" />
          <rect width="17.5" height="46" fill="#ffffff" rx="1" />
          <circle cx="43.75" cy="23" r="12" fill="#ffffff" />
          <circle cx="46.75" cy="20" r="12" fill="#006600" />
          <path d="M48,15 L50,21 L56,21 L51,25 L53,31 L48,27 L43,31 L45,25 L40,21 L46,21 Z" fill="#ffffff" transform="rotate(-20 48 23)" />
        </svg>
      </div>
    </div>
);
